<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('death.Destructor_UBN') }}</h5>
    <!--p class="mb-0 text-sm">{{ $t('death.Choose_the_destructor_to_which_the_animal_has_been_removed') }}</p-->
    <p class="mb-0 text-sm">{{ $t('death.NB_destructor_may_only_be_emptied') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('death.Destructor_UBN') }}</label>
                <select id="departureUbnId" v-model="localFormData.departureUbnId" class="form-control form-control-default">
                    <option value="">{{ $t('death.Select_UBN') }}</option>
                    <option v-for="item in departureubns" :key="item.id" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>
        </div>        
      </div>      
      <div class="row mt-3">
          <div class="col-12 text-success">
              {{ $t('death.Check_the_data_of_the_animals_to_be_departed_before_you_save') }}        
          </div>
      </div>   
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
  import { reactive, watch } from 'vue'
  
  export default {
    name: "DepartureUbn",
    props: {
      departureubns: Array,
      exportcountries: Array,
      formData: Object,
      prevStep: Function,
      nextStep: Function
    },
    setup(props, { emit }) {      
      const localFormData = reactive(props.formData);

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndPrevStep = async () => {
          props.prevStep()
      }

      const validateAndSubmit = async () => {        

        Object.assign(props.formData, localFormData)
        emit('submit')
        return true
      }     

      return {
        localFormData,               
        validateAndPrevStep,
        validateAndSubmit
      }
    }    
};
</script>
<style scoped>
.card {
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  position: relative;
  padding: 10px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.bg-light {
  background-color: #f9f9f9 !important;
}
.border-success {
  border-color: #28a745 !important;
}
</style>